import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type ThemeMode = 'dark' | 'light';

interface ThemeState {
  mode: ThemeMode;
  hasUserPreference: boolean;
  setMode: (mode: ThemeMode) => void;
  toggle: () => void;
}

const getSystemTheme = (): ThemeMode => {
  if (typeof window === 'undefined') return 'dark';
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
};

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: getSystemTheme(),
      hasUserPreference: false,
      setMode: (mode) => set({ mode, hasUserPreference: true }),
      toggle: () =>
        set({ mode: get().mode === 'dark' ? 'light' : 'dark', hasUserPreference: true }),
    }),
    {
      name: 'gretabot.theme',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
